/* eslint-disable import/no-unresolved */
import React, { useEffect, useRef } from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { CSSTransition } from "react-transition-group"
import styled from "styled-components"
import tw from "twin.macro"

import { OtherProjects } from "@components"
import { Icon } from "@components/icons"
import { CustomHeading } from "@templates"
import scrollReveal from "@utils/scroll.reveal"
import { srConfig } from "@config"
import { Workspace } from "../components"

const StyledProject = styled.section`
  ${tw`min-h-full text-suvaGrey px-8 mb-12`}
  & {
    .custom-heading {
      ${tw``}
    }
  }
`

const DisplayProject = styled.div`
  ${tw`mt-12 grid gap-10`}
  }
`

const Projects = () => {
  const data = useStaticQuery(graphql`
    query {
      projects: allMarkdownRemark(
        filter: {
          fileAbsolutePath: { regex: "/projects/" }
          frontmatter: { showInProjects: { ne: false } }
        }
        sort: { fields: [frontmatter___date], order: DESC }
      ) {
        edges {
          node {
            frontmatter {
              title
              cover {
                childImageSharp {
                  fluid(maxWidth: 700, traceSVG: { color: "#161718" }) {
                    ...GatsbyImageSharpFluid_withWebp_tracedSVG
                  }
                }
              }
              tech
              github
              external
              company
            }
            html
          }
        }
      }
    }
  `)

  const projects = data.projects.edges.filter(({ node }) => node)

  const revealContainer = useRef(null)
  useEffect(() => scrollReveal.reveal(revealContainer.current, srConfig()), [])

  return (
    <div>
      <StyledProject id="projects" ref={revealContainer}>
        <CustomHeading
          title="Projects"
          subTitle="Finally, it's project time. Below are some projects that I've built"
        />

        <DisplayProject>
          {projects &&
            projects.map(({ node }, i) => (
              <CSSTransition key={i} timeout={250} classNames="fade">
                <Workspace getNode={node} idx={i} />
              </CSSTransition>
            ))}
        </DisplayProject>
      </StyledProject>

      <StyledProject>
        <OtherProjects />
      </StyledProject>
    </div>
  )
}

export default Projects
